module.exports = __webpack_public_path__ + "img/img40.35082e1d.svg";